import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const ImageWrapper = styled.div`
    margin: 0 auto;
    position: relative;
    
    img {
        width: 100%;
        height: 134px;
        object-fit: contain;
        object-position: center center;
    
        @media (max-width: ${wideBreakpoints.mobile}) {
            height: 96px;
        }
    }
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    position: absolute;
    z-index: 1000;
    top: 4px;
    left: 8px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        top: 6px;
        left: 12px;
    }
`;
